export const achievements = [
  {
    id: "academic-milestone",
    title: "100% Primary School Readiness",
    category: "Academic milestones",
    iconName: "GraduationCap",
    desc: "Every single UKG graduate successfully transitioned and secured admission in leading primary schools of Bhubaneswar."
  },
  {
    id: "creative-award",
    title: "Inter-School Art Laurels",
    category: "Creative achievements",
    iconName: "Palette",
    desc: "Our senior kindergarten students won the top three prizes in the District Early Creators Drawing Competition."
  },
  {
    id: "sports-participation",
    title: "District Kids Athletics Trophy",
    category: "Sports participation",
    iconName: "Trophy",
    desc: "Happykidz students were awarded the 'Best Sportsmanship' trophy in the local Under-6 track events."
  },
  {
    id: "confidence-communication",
    title: "Rhyme Recitation Awards",
    category: "Confidence and communication",
    iconName: "Mic",
    desc: "Nursery and Pre-KG students recognized for exceptional poise and clear recitation during the annual taluk meets."
  },
  {
    id: "competition-participation",
    title: "100% Student Stage Participation",
    category: "Competition participation",
    iconName: "Users",
    desc: "We ensure every single child participates in our Annual Day stage performances to build self-confidence."
  },
  {
    id: "graduation-milestones",
    title: "15th Graduation Milestone",
    category: "Graduation milestones",
    iconName: "Award",
    desc: "Celebrated our 15th graduating batch of UKG students, honoring their growth, values, and early learning journey."
  }
];
